import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import downIcon from "../../assets/double-down.svg";

const Banner = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box
      sx={{
        backgroundColor: "#b4c424",
        padding: "20px",
        textAlign: "center",
        position: "relative",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-around",
      }}
    >
      <Box
        textAlign={"center"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
      >
        <Typography
          variant="h4"
          component="div"
          sx={{ fontWeight: "bold", color: "white" }}
        >
          Let’s Get Started On Your Remodel!
        </Typography>
        <Typography
          variant="h4"
          component="div"
          sx={{ color: "white", marginBottom: "10px" }}
        >
          Contact us for a free estimate today.
        </Typography>
      </Box>
      <Box>
        <img src={downIcon} alt="downIcon" height={isMobile ? 100 : 200} />
      </Box>
    </Box>
  );
};

export default Banner;
